import { Navigate, useLocation } from 'react-router-dom';
import { useLoginStore, useVerifyCodeStore } from '@lib/store';
import { LocalStorageUtils, RoutePaths } from '@shared/utils';
import { useEffect } from 'react';
import { useRouteHook } from '@shared/hooks';

export const PrivateRoute = (props: { children: React.ReactNode }) => {
  const { navigate } = useRouteHook();

  const loginStore = useLoginStore();
  const verifyCodeStore = useVerifyCodeStore();

  const location = useLocation();

  const storageData = LocalStorageUtils.getStuff();

  useEffect(() => {
    if (!storageData) {
      loginStore.clear();
      verifyCodeStore.clear();
      navigate(RoutePaths.login.onNavigate());
    }
  }, [storageData]);

  const isLoggedIn = storageData?.token && !storageData.secondFactorEnabled;

  return isLoggedIn ? props.children : <Navigate to={RoutePaths.login.onNavigate()} state={{ from: location.pathname }} />;
};
